var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('cs-dialog', {
    model: {
      value: _vm.isShownDialog,
      callback: function callback($$v) {
        _vm.isShownDialog = $$v;
      },
      expression: "isShownDialog"
    }
  }, [_c('dialog-list-layout', _vm._l(_vm.presets, function (_ref, intervalKey) {
    var _class;

    var label = _ref.label,
        diff = _ref.diff;
    return _c('div', {
      key: "period_".concat(intervalKey, "_").concat(diff),
      class: (_class = {}, _class[_vm.$style.container] = true, _class[_vm.$style.active] = _vm.isActivePreset(intervalKey), _class),
      on: {
        "click": function click($event) {
          return _vm.handleClick(intervalKey);
        }
      }
    }, [_c('div', {
      class: _vm.$style.content
    }, [_c('div', {
      class: _vm.$style.title
    }, [_vm._v(" " + _vm._s(_vm.$t(label)) + " ")])])]);
  }), 0)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }